import { render, staticRenderFns } from "./BlackbookUpcomingJockeyAndtrainer.vue?vue&type=template&id=60fe3ecc&scoped=true"
import script from "./BlackbookUpcomingJockeyAndtrainer.vue?vue&type=script&lang=js"
export * from "./BlackbookUpcomingJockeyAndtrainer.vue?vue&type=script&lang=js"
import style0 from "./BlackbookUpcomingJockeyAndtrainer.vue?vue&type=style&index=0&id=60fe3ecc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fe3ecc",
  null
  
)

export default component.exports